export const NAV_ITEMS = [
  { id: "home", label: "Home", href: "#home" },
  { id: "works", label: "Projetos", href: "#works" },
  { id: "about", label: "Sobre", href: "#about" },
  { id: "contact", label: "Contato", href: "#contact" },
];

export const SECTION_IDS = NAV_ITEMS.map((item) => item.id);
